var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonFilterBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09512 16.1665H0.759766",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2402 16.1665C19.2402 16.7664 19.069 17.3527 18.7484 17.8516C18.4278 18.3504 17.972 18.7392 17.4388 18.9688C16.9057 19.1983 16.319 19.2585 15.753 19.1414C15.187 19.0244 14.667 18.7355 14.259 18.3113C13.8509 17.8871 13.573 17.3466 13.4604 16.7583C13.3478 16.1699 13.4056 15.5599 13.6264 15.0057C13.8473 14.4514 14.2213 13.9778 14.7011 13.6445C15.181 13.3112 15.7451 13.1333 16.3222 13.1333C16.7054 13.1333 17.0848 13.2118 17.4388 13.3642C17.7929 13.5166 18.1146 13.74 18.3855 14.0217C18.6565 14.3033 18.8714 14.6377 19.018 15.0057C19.1647 15.3737 19.2402 15.7682 19.2402 16.1665V16.1665Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9043 3.82324H19.2396",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.759766 3.82322C0.759766 4.42313 0.930883 5.00949 1.25151 5.50829C1.57214 6.00709 2.02789 6.39593 2.56108 6.6255C3.09426 6.85508 3.68091 6.91507 4.24693 6.79803C4.81296 6.681 5.33288 6.3921 5.74096 5.9679C6.14904 5.54371 6.42696 5.00324 6.53955 4.41487C6.65214 3.82649 6.59437 3.21667 6.37352 2.66243C6.15266 2.10819 5.77867 1.63449 5.29881 1.3012C4.81896 0.967915 4.25482 0.790039 3.6777 0.790039C3.29452 0.790039 2.9151 0.868506 2.56108 1.02094C2.20706 1.17337 1.88534 1.39675 1.61438 1.67841C1.34343 1.96006 1.12853 2.29442 0.981892 2.66243C0.835252 3.03043 0.759766 3.4249 0.759766 3.82322V3.82322Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonFilterBlack);
export default __webpack_public_path__ + "static/media/button_filter-black.ace89a83d6aec123cc36177096dc7cb7.svg";
export { ForwardRef as ReactComponent };